import { useTranslation } from 'react-i18next';
import { ROUTES } from './routes';

interface PageTitleMap {
  [key: string]: string;
}

export const PAGE_TITLES = (): PageTitleMap => {
  const { t } = useTranslation();

  return {
    [ROUTES.LOGIN]: t('page_titles.login'),
    [ROUTES.MAP_OVERVIEW]: t('page_titles.fleet_view'),
    [ROUTES.DRIVERS]: t('page_titles.drivers'),
    [ROUTES.VEHICLES]: t('page_titles.vehicles'),
    [ROUTES.SAFETY_CONCERNS]: t('page_titles.safety_concerns'),
    [ROUTES.SAFETY]: t('page_titles.safety'),
    [ROUTES.SAFETY_ID]: t('page_titles.concern_details'),
    [ROUTES.REPORTS]: t('page_titles.reports'),
    [ROUTES.LIVEVIEW]: t('page_titles.liveview'),
    [ROUTES.LIVEVIEW_V2]: t('page_titles.liveview'),
    [ROUTES.VEHICLE_SUMMARY]: t('page_titles.vehicle_summary'),
    [ROUTES.DRIVER_PERFORMANCE]: t('page_titles.driver_performance'),
    [ROUTES.NOTIFICATIONS]: t('page_titles.notifications'),
    [ROUTES.MILEAGE_REPORT]: t('page_titles.mileage_report'),
    [ROUTES.DRIVER_UTILIZATION]: t('page_titles.driver_utilization'),
    [ROUTES.VEHICLE_UTILIZATION]: t('page_titles.vehicle_utilization'),
    [ROUTES.IDLE_REPORT]: t('page_titles.idle_report'),
    [ROUTES.HOURS_OF_SERVICE]: t('page_titles.hours_of_service'),
    [ROUTES.DAILY_VEHICLE]: t('page_titles.daily_vehicle'),
    [ROUTES.MISSING_DRIVER]: t('page_titles.missing_driver'),
    [ROUTES.ADMIN]: t('page_titles.admin'),
    [ROUTES.ADMIN_USER]: t('page_titles.admin_user'),
    [ROUTES.ADMIN_ROLE]: t('page_titles.admin_role'),
    [ROUTES.ADMIN_DEVICE]: t('page_titles.admin_device'),
    [ROUTES.ADMIN_VEHICLE]: t('page_titles.admin_vehicle'),
    [ROUTES.ADMIN_ORGANIZATION]: t('page_titles.admin_organization'),
    [ROUTES.ADMIN_RELEASE_VERSION]: t('page_titles.admin_release_version'),

    [ROUTES.MAINTENANCE]: t('page_titles.maintenance'),
    [ROUTES.CREATE_SCHEDULE]: t('page_titles.maintenance'),
    [ROUTES.EDIT_SCHEDULE]: t('page_titles.maintenance'),
    [ROUTES.VIEW_SCHEDULE]: t('page_titles.maintenance'),
    [ROUTES.GROUPS]: t('page_titles.groups'),
    [ROUTES.VIEWMANAGEGROUPS]: t('page_titles.groups'),

    [ROUTES.PROFILE]: t('page_titles.profile'),
    [ROUTES.ROUTES_OPTIMIZATION]: t('page_titles.route_optimization'),
    [ROUTES.VIEW_ROUTE]: t('page_titles.route_optimization'),
  };
};
